import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div
      data-testid="notfound-page"
      className="min-h-[70vh] flex items-center justify-center px-6 py-32"
    >
      <div className="max-w-xl text-center">
        <div className="overline mb-4">404</div>
        <h1 className="font-display text-5xl md:text-6xl text-[#1A2421] tracking-tight leading-[1.05] mb-5">
          This page has moved or doesn't exist.
        </h1>
        <p className="text-[#4A5D54] mb-8 leading-relaxed">
          Head back to our home, or explore our vision and mission for what's next.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/" data-testid="notfound-home-cta" className="btn-primary">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
          <Link to="/mission" data-testid="notfound-mission-cta" className="btn-ghost">
            Our Mission
          </Link>
        </div>
      </div>
    </div>
  );
}
